var map = {
	"./arbitri.png": 5689,
	"./classbut.png": 6587,
	"./classcp.png": 6349,
	"./classsq.png": 5460,
	"./confrscore.png": 2408,
	"./curriculum.png": 2959,
	"./figb.png": 8730,
	"./incontri.png": 1416,
	"./inviaris.png": 1873,
	"./mostraris.png": 6944,
	"./movim.png": 8396,
	"./sendDeal.png": 2882,
	"./tavolo.png": 9901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 989;